import React from "react";
import "./Departments.css";

const LaghuPaatbandhareVibhag = () => {
  return (
    <div className="dept-page">

      {/* TOP STRIP */}
      <div className="dept-top-strip">
        <span>🏛 महाराष्ट्र शासन</span>
        <span>जिल्हा परिषद ल.पा विभाग</span>
      </div>

      {/* HEADER */}
      <header className="dept-header">

        <div className="dept-header-emblem">
          🌊
        </div>

        <div className="dept-header-text">

          <div className="dept-header-org">
            जिल्हा परिषद विभाग
          </div>

          <h1 className="dept-header-title">
            जिल्हा परिषद (ल.पा) विभाग
          </h1>

          <div className="dept-header-subtitle">
            लघु सिंचन व जलसाठा विकास विभाग
          </div>

        </div>

        <div className="dept-header-badge">
          MINOR IRRIGATION
        </div>

      </header>

      {/* NAVIGATION */}
      <div className="dept-nav">

        <button className="dept-nav-tab active">
          विभाग माहिती
        </button>

        <button className="dept-nav-tab">
          सिंचन योजना
        </button>

        <button className="dept-nav-tab">
          जलसाठा विकास
        </button>

        <button className="dept-nav-tab">
          संपर्क
        </button>

      </div>

      {/* MAIN */}
      <main className="dept-main">

        {/* HERO */}
        <section className="dept-intro">

          <div className="dept-intro-label">
            जलसंधारण व सिंचन विकास
          </div>

          <p className="dept-intro-text">
            <strong>जिल्हा परिषद ल.पा विभाग</strong>
            हा विभाग ग्रामीण भागातील लघु सिंचन,
            जलसाठा निर्मिती आणि शेतीसाठी पाणी
            उपलब्ध करून देण्यासाठी कार्यरत आहे.
            जिल्ह्यातील १०० हेक्टर पर्यंत सिंचन
            क्षमतेच्या योजना राबवून शेती उत्पादन
            वाढीस चालना देणे आणि जलसंधारण
            बळकट करणे हा विभागाचा मुख्य उद्देश आहे.
          </p>

        </section>

        {/* STATS */}
        <section className="dept-stats">

          <div className="dept-stat-card">
            <div className="dept-stat-value">2631</div>
            <div className="dept-stat-label">
              लघु सिंचन योजना
            </div>
          </div>

          <div className="dept-stat-card">
            <div className="dept-stat-value">58,136</div>
            <div className="dept-stat-label">
              सिंचनाखालील क्षेत्र (हे.)
            </div>
          </div>

          <div className="dept-stat-card">
            <div className="dept-stat-value">141487</div>
            <div className="dept-stat-label">
              जलसाठा क्षमता (घ.मी.)
            </div>
          </div>

          <div className="dept-stat-card">
            <div className="dept-stat-value">100</div>
            <div className="dept-stat-label">
              हेक्टर पर्यंत योजना
            </div>
          </div>

        </section>

        {/* LEFT CONTENT */}
        <div>

          {/* ABOUT */}
          <section className="dept-section">

            <div className="dept-section-header">

              <div className="dept-section-icon">
                💧
              </div>

              <h2 className="dept-section-title">
                विभागाची माहिती
              </h2>

            </div>

            <div className="scheme-list">

              <div className="scheme-card">

                <div className="scheme-card-name">
                  भौगोलिक वैशिष्ट्ये
                </div>

                <div className="scheme-card-desc">
                  पुणे जिल्ह्याचे एकूण भौगोलिक
                  क्षेत्र १५,६२,०५८ हेक्टर असून
                  त्यापैकी ७४% क्षेत्र लागवडीयोग्य आहे.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  पश्चिम भाग
                </div>

                <div className="scheme-card-desc">
                  डोंगराळ व अतिपावसाचा भाग असून
                  पावसाळ्यानंतर पाण्याची टंचाई
                  जाणवते.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  पूर्व भाग
                </div>

                <div className="scheme-card-desc">
                  पठारी व अवर्षण प्रवण भाग असून
                  शेतीसाठी सिंचनाच्या पाण्याची
                  मोठ्या प्रमाणात गरज आहे.
                </div>

              </div>

            </div>

          </section>

          {/* IRRIGATION TYPES */}
          <section
            className="dept-section"
            style={{ marginTop: "24px" }}
          >

            <div className="dept-section-header">

              <div className="dept-section-icon">
                🌾
              </div>

              <h2 className="dept-section-title">
                सिंचन विभागांचे वर्गीकरण
              </h2>

            </div>

            <div className="scheme-list">

              <div className="scheme-card">

                <div className="scheme-card-name">
                  ० ते १०० हेक्टर प्रकल्प
                </div>

                <div className="scheme-card-desc">
                  जिल्हा परिषद लघु पाटबंधारे
                  विभागामार्फत राबविले जातात.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  १०१ ते ६०० हेक्टर प्रकल्प
                </div>

                <div className="scheme-card-desc">
                  मृद व जलसंधारण विभाग
                  (राज्यस्तर) मार्फत राबविले जातात.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  ६०१ हेक्टर वरील प्रकल्प
                </div>

                <div className="scheme-card-desc">
                  जलसंपदा विभागामार्फत
                  अंमलबजावणी केली जाते.
                </div>

              </div>

            </div>

          </section>

          {/* SCHEMES */}
          <section
            className="dept-section"
            style={{ marginTop: "24px" }}
          >

            <div className="dept-section-header">

              <div className="dept-section-icon">
                🏞
              </div>

              <h2 className="dept-section-title">
                लघु सिंचन योजना
              </h2>

            </div>

            <div className="scheme-list">

              <div className="scheme-card">
                <div className="scheme-card-name">
                  पाझर तलाव व गाव तलाव
                </div>
                <div className="scheme-card-desc">
                  ० ते १०० हेक्टर सिंचन
                  क्षमतेच्या तलाव योजना.
                </div>
              </div>

              <div className="scheme-card">
                <div className="scheme-card-name">
                  साठवण बंधारे
                </div>
                <div className="scheme-card-desc">
                  पाणी साठवण व शेतीसाठी
                  पाणी उपलब्धता वाढविणे.
                </div>
              </div>

              <div className="scheme-card">
                <div className="scheme-card-name">
                  वळण बंधारे
                </div>
                <div className="scheme-card-desc">
                  पाण्याचे योग्य व्यवस्थापन
                  व सिंचनासाठी वापर.
                </div>
              </div>

              <div className="scheme-card">
                <div className="scheme-card-name">
                  कोल्हापूर पद्धतीचे बंधारे
                </div>
                <div className="scheme-card-desc">
                  पाणी अडवून सिंचन क्षमता
                  वाढविणाऱ्या योजना.
                </div>
              </div>

              <div className="scheme-card">
                <div className="scheme-card-name">
                  भूसंपादन योजना
                </div>
                <div className="scheme-card-desc">
                  पाझर तलावासाठी खाजगी
                  जमिनीचे भूसंपादन.
                </div>
              </div>

              <div className="scheme-card">
                <div className="scheme-card-name">
                  नादुरुस्त योजना दुरुस्ती
                </div>
                <div className="scheme-card-desc">
                  ० ते १०० हेक्टर पर्यंतच्या
                  जुन्या योजनांची दुरुस्ती.
                </div>
              </div>

            </div>

          </section>

          {/* SERVICES */}
          <section
            className="dept-section"
            style={{ marginTop: "24px" }}
          >

            <div className="dept-section-header">

              <div className="dept-section-icon">
                ⚙️
              </div>

              <h2 className="dept-section-title">
                प्रमुख सेवा
              </h2>

            </div>

            <div className="dept-services-grid">

              <div className="dept-service-item">
                सिंचन विकास
              </div>

              <div className="dept-service-item">
                जलसाठा निर्मिती
              </div>

              <div className="dept-service-item">
                बंधारे बांधकाम
              </div>

              <div className="dept-service-item">
                तलाव विकास
              </div>

              <div className="dept-service-item">
                योजना दुरुस्ती
              </div>

              <div className="dept-service-item">
                जल व्यवस्थापन
              </div>

            </div>

          </section>

        </div>

        {/* SIDEBAR */}
        <aside className="dept-sidebar">

          {/* INFO */}
          <div className="dept-info-card">

            <div className="dept-info-card-title">
              विभाग माहिती
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                कार्यक्षेत्र
              </div>

              <div className="dept-info-val">
                ० ते १०० हे.
              </div>
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                एकूण योजना
              </div>

              <div className="dept-info-val">
                2631
              </div>
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                जलसाठा
              </div>

              <div className="dept-info-val">
                141487 घ.मी.
              </div>
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                सिंचन क्षेत्र
              </div>

              <div className="dept-info-val">
                58,136 हे.
              </div>
            </div>

          </div>

          {/* CONTACT */}
          <div className="dept-contact-card">

            <div className="dept-contact-card-title">
              संपर्क माहिती
            </div>

            <div className="dept-contact-row">
              <span>📞</span>
              <span>020-26131605</span>
            </div>

            <div className="dept-contact-row">
              <span>📍</span>
              <span>जिल्हास्तरीय कार्यालये</span>
            </div>

            <div className="dept-contact-row">
              <span>🌊</span>
              <span>लघु पाटबंधारे विभाग</span>
            </div>

          </div>

          {/* HIGHLIGHT */}
          <div className="dept-highlight-box">

            <div className="dept-highlight-box-title">
              📌 विशेष माहिती
            </div>

            <p>
              जिल्हा परिषद ल.पा विभागामार्फत
              तलावातील मुरूम उचलण्यासाठी
              ना हरकत दाखला प्रणाली उपलब्ध आहे.
            </p>

          </div>

          {/* QUICK SERVICES */}
          <div className="dept-info-card">

            <div className="dept-info-card-title">
              प्रमुख योजना
            </div>

            <div className="dept-services-grid">

              <div className="dept-service-item">
                पाझर तलाव
              </div>

              <div className="dept-service-item">
                गाव तलाव
              </div>

              <div className="dept-service-item">
                साठवण बंधारे
              </div>

              <div className="dept-service-item">
                वळण बंधारे
              </div>

              <div className="dept-service-item">
                KP बंधारे
              </div>

              <div className="dept-service-item">
                योजना दुरुस्ती
              </div>

            </div>

          </div>

        </aside>

      </main>

      {/* FOOTER */}
      <footer className="dept-footer">
        <strong>जिल्हा परिषद ल.पा विभाग</strong>
        {" "}• जिल्हा परिषद प्रशासन
      </footer>

    </div>
  );
};

export default LaghuPaatbandhareVibhag;